import React from 'react';
import { Form, InputNumber, Divider } from 'antd';
import { configShort } from '../../../../../common/utils/configFormField';

class Section2 extends React.Component {
  render() {
    const { getFieldDecorator } = this.props.form;
    const { fields, disabledFields } = this.props;
    return (
      <div className="sectionCompensation">
        <Divider />
        <h1 className="header">Компенсации фрахтовщику от фрахтователя</h1>
        <div className="colsLayout">
          <span className="label">
            Отказ фрахтователя от договора свыше
            <br />
            хх часов до подачи ТС (КП1):
          </span>
          <Form.Item>
            {getFieldDecorator('section2_1', configShort(fields['section2_1']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('section2_2', configShort(fields['section2_2']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Отказ фрахтователя от договора
            <br />
            за хх часов до подачи ТС (КП2):
          </span>
          <Form.Item>
            {getFieldDecorator('section2_3', configShort(fields['section2_3']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('section2_4', configShort(fields['section2_4']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Отказ фрахтователя от договора
            <br />
            за хх часов до подачи ТС (КП3):
          </span>
          <Form.Item>
            {getFieldDecorator('section2_5', configShort(fields['section2_5']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('section2_6', configShort(fields['section2_6']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Отказ фрахтователя от договора
            <br />
            за хх часов до подачи ТС (КП4):
          </span>
          <Form.Item>
            {getFieldDecorator('section2_7', configShort(fields['section2_7']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('section2_8', configShort(fields['section2_8']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
        </div>
      </div>
    );
  }
}

export default Section2;
